// Supabase 클라이언트 — env vars 가 없으면 client = null (앱이 auth 없이도 동작)
//
// CF Pages env vars 에 다음 두 개를 추가하세요:
//   REACT_APP_SUPABASE_URL = https://xxxxx.supabase.co
//   REACT_APP_SUPABASE_PUBLISHABLE_KEY = sb_publishable_... (브라우저 안전 키)
//
// 참고: Supabase 가 "anon key" 를 "Publishable key" 로 명칭 변경했습니다.
//       기존 ANON_KEY env var 이름도 backward-compat 로 인식.
//       기능적으로 동일 키 — RLS 설정만 되어 있으면 브라우저 노출 안전.
//
// 로컬 dev 는 프로젝트 루트의 .env.local 에 동일 키 추가 (gitignored).

import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase =
  url && publishableKey
    ? createClient(url, publishableKey, {
        auth: {
          // 세션을 localStorage 에 자동 저장·복원
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true, // OAuth 콜백 처리
        },
      })
    : null;

export const isSupabaseEnabled = !!supabase;
